import {useIntl} from 'react-intl'

function useGiftCardFields({
    form: {
        control,
        formState: {errors},
        watch
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const fields = {
        giftCardNumber: {
            name: `${prefix}giftCardNumber`,
            label: formatMessage({
                defaultMessage: 'Gift Card Number',
                id: 'useGiftCardFields.label.giftCardNumber_checkout'
            }),
            type: 'text',
            autoComplete: 'new-giftCardNumber',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter a gift card code.',
                    id: 'useGiftCardFields.label.giftCardNumber.error_checkout'
                })
            },
            error: errors[`${prefix}giftCardNumber`],
            control
        },
        pin: {
            name: `${prefix}pin`,
            label: formatMessage({
                defaultMessage: 'Pin',
                id: 'useGiftCardFields.label.pin_checkout'
            }),
            type: 'text',
            autoComplete: 'new-pin',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter 4 digit gift card pin.',
                    id: 'useGiftCardFields.label.pin.error_checkout'
                })
            },
            error: errors[`${prefix}pin`],
            control
        }
    }

    return fields
}

export default useGiftCardFields
